<div class="widget-grid h-100">
    <div class="drag-area">
        @if (showFacility()) {
            <div
                #facilityBar
                class="widget-facility-bar text-center"
            >
                Facility:
                <span [class]="!infoService.userFacility()?.name ? 'text-danger' : 'text-white'">
                    {{ infoService.userFacility()?.name ?? 'No Facility Selected' }}
                </span>
            </div>
        }
        <div class="widget-header" #widgetHeader>
            <ng-content select="[widget-header]">
                <span class="widget-title">
                    <ng-content select="[widget-title]" />
                </span>
                <ng-content select="[widget-meta]" />
            </ng-content>
        </div>
    </div>
    <div class="widget-subheader" #widgetSubHeader>
        <ng-content select="[widget-subheader]" />
    </div>
    <div class="widget-body" #widgetBody>
        <ng-content select="[widget-body]" />
    </div>
</div>
